/**
 * Contenu Draft.js sérialisé (`{ blocks, entityMap }`), tel que le classique
 * le stocke dans les textes et les cellules. Module partagé document ↔ site :
 * pur, sans draft-js.
 */

/** Le contenu Draft brut, ou `null` si la valeur est du texte ou du HTML. */
export function parseDraftRaw(value) {
  if (!value || typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed.startsWith('{')) return null;
  try {
    const raw = JSON.parse(trimmed);
    return Array.isArray(raw?.blocks) ? raw : null;
  } catch {
    return null;
  }
}

/** Le texte nu d'un contenu Draft brut, une ligne par bloc. */
export const draftRawText = (raw) => raw.blocks.map((block) => block?.text ?? '').join('\n');
